/**
 * Build-time product flags.
 *
 * Day One is free. The only thing this flag still controls is whether the legal
 * pages name Stripe as a subprocessor, so that if the service ever charges for
 * something the disclosures come back with it.
 */
export const PAYMENTS_ENABLED = import.meta.env.VITE_PAYMENTS_ENABLED === 'true'
